module.exports = __webpack_public_path__ + "static/media/pdf_icon.10113b66.svg";